import { LOCK } from 'Data/payment-plan.js'

export function getView(lock) {
  return lock === LOCK.DOWNPAYMENT_AMOUNT ? 'UnlockIcon' : 'LockIcon'
}
